import { copyTextToClipboard } from '@/Pages/PostsListPage/utils';
import Button from '@/components/atoms/Button/Button';
import { useAppContext } from '@/context/AppContext/AppContext';
import { showSuccessToast } from '@/libs/toast/toast';
import useAnalytics from '@/hooks/useAnalytics';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import Icon from '@/components/atoms/Icon';

export default function ClipShareLinkTab() {
  const { logger } = useAppContext();
  const { trackContentShare } = useAnalytics();
  const { clipId, clipData } = useClipsContext();

  const clipShareLink = `${window.location.origin}/shared/clip/${clipId}`;

  const handleOpenShareLink = () => {
    window.open(clipShareLink, '_blank');
  };

  const handleCopyShareLink = () => {
    copyTextToClipboard(clipShareLink, logger);
    trackContentShare({ contentType: 'CLIP', source: 'EditorPage', shareType: 'CopyURL', asset: clipData });
    showSuccessToast('Link copied to clipboard!');
  };

  return (
    <div className="mt-2 p-2">
      <div className="flex w-full items-center space-x-2 px-1.5">
        <div className="w-6">
          <Icon name="IconWorld" className="size-6" />
        </div>
        <div className="w-full text-xs font-medium leading-tight">
          Public Access
          <div className="text-xs font-normal">Everyone with the link can view</div>
        </div>
        <Button
          trackingId="open-share-link-button"
          buttonSize="small"
          variation="outline"
          className="!px-1.5"
          onClick={handleOpenShareLink}
        >
          <Icon name="IconArrowUpRight" className="size-[18px]" />
        </Button>
      </div>
      <input className="mt-3 w-full rounded-lg border p-2.5 text-sm text-slate-500" disabled value={clipShareLink} />
      <Button
        buttonSize="large"
        variation="filled"
        className="mt-2 h-12 w-full rounded-lg"
        trackingId="copy-share-link-button"
        onClick={handleCopyShareLink}
      >
        Copy Link
      </Button>
    </div>
  );
}
